module.exports = __webpack_public_path__ + "static/media/blinds-raised.cde637d0.svg";